import React from "react";
import {TEXT_TYPES} from "../../../constants/APP_CONSTANTS";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import ReactTable from "react-table";
import urlHelper from "../../../_helpers/url.format.helper";
import config from "../../../config";
import AxiosClient from "../../../_helpers/http.helper";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import union from "lodash/union";
import { Link } from "react-router-dom";

export default class ViewBatchLogs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contentIngestionBatchLogs: [],
            pageSize: 25,
            pageNumber: null,
            totalItems: 0,
            hasMore: true,
            selectedBatchId: null,
            isLoading : true
        };

    }

    componentDidMount() {
        this.loadMore();
    }

    loadMore = () => {
        this.getBatchLogs().then(results => {
            const userList = this.createUserIdpayload(results.data.content);
            return {userList, results};
        }).then(result => {
            const {userList, results} = result;
            this.getUserList(userList).then((userInfo) => {
                const userMap = this.createAnUserHashMap(userInfo.data);

                results.data.content.map(batch => {
                    batch.creator = userMap[batch.creator];
                });

                this.setState(prevState => ({
                    contentIngestionBatchLogs: union([
                        ...prevState.contentIngestionBatchLogs,
                        ...results.data.content
                    ], 'batchId'),
                    pageNumber: results.data.number,
                    totalItems: results.data.totalElements,
                    hasMore: !results.data.last,
                    isLoading: false
                }));
            });
        });
    };

    getBatchLogs = () => {
        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.getContentIngestionBatchLogs,
            {
                pageSize: this.state.pageSize,
                pageNumber:
                    this.state.pageNumber === null
                        ? 0
                        : this.state.pageNumber + 1
            }
        );
        return AxiosClient.get(url);
    };

    createUserIdpayload = (batches) => {
        const userList = [];
        batches.map(batch => {
            if (!userList.includes(batch.creator)) {
                userList.push(batch.creator);
            }
        });
        return userList;
    };

    getUserList = (payload) => {
        const url = urlHelper.formatUrl(
            config.identity.baseUrl,
            config.identity.routes.getUsersList);
        return AxiosClient.post(url, payload);
    };

    createAnUserHashMap = (userInfoList) => {
        let userMap = {};
        userInfoList.map(user => {
            userMap = {
                ...userMap,
                [user.id]: user.firstName+" "+user.lastName
            };
        });
        return userMap;
    };

    render() {
        const columns = [
            {
                Header: "Batch ID",
                accessor: "batchId",
                sortable: true,
                Cell: (row) => (
                    <Link to={`/batch-details/${row.value}`}>{row.value}</Link>
                ),
                width: 200
            },
            {
                Header: "Filename",
                accessor: "metadataIngestionStatus[0].fileName",
                sortable: true
            },
            {
                Header: "UploadDate",
                id: "creationDate",
                accessor: d =>
                    moment(d.creationDate)
                        .utc()
                        .format("MM/DD/YY HH:mm z"),
                sortable: true
            },
            {
                Header: "Creator",
                accessor: "creator",
                sortable: true
            },
        ];

        return (
            <div className="content-home-page cc-creation-status">
                <div>
                    <label className="pe-page-title--small">
                        {TEXT_TYPES.VIEW_LOGS}
                    </label>
                    <hr/>{this.state.totalItems > 0 && <h3> Total batches: {this.state.totalItems}</h3> }
                </div> {this.state.isLoading && <LoadingIndicator/>}
                <div className="pe-row">
                    <div className="pe-col-12 pt-4">
                        {this.state.totalItems > 0 && (
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={
                                        this.state.contentIngestionBatchLogs
                                            .length
                                    }
                                    next={this.loadMore}
                                    hasMore={this.state.hasMore}
                                    loader={<LoadingIndicator/>}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight -striped"
                                            data={
                                                this.state.contentIngestionBatchLogs
                                            }
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={
                                                this.state.totalItems
                                            }
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            noDataText="No batch details found"
                                            getTrProps={() => {
                                                return {
                                                    style: {
                                                        textAlign: "center",
                                                    }
                                                };
                                            }}
                                        />
                                    </div>
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ContentIngestion/ViewBatchLogs.js